exports.default = {
  // Sidebar Navigation
  'general': 'General',
  'domains': 'Domains',
  
  // General Settings Panel
  'current_version': 'Version: {version}',
  'open_website': 'Open Website',
  'publish_and_access': 'Publish & Access',
  'domain': 'Domain',
  'custom_domain': 'Custom Domain',
  'your_website_not_online': 'Your website is not yet online. It is only accessible through the preview link.',
  'status': 'Status',
  'online': 'Online',
  'publishing': 'Publishing',
  'not_published': 'Not Published',
  'publish': 'Publish',
  'unpublish': 'Unpublish',
  
  // Domain Settings Panel
  'copy': 'Copy',
  'not_generated_link': 'Link not generated yet',
  'custom_domain_with_icon': 'Custom Domain',
  'keep_subscription_valid': 'To ensure your custom domain remains accessible, please keep your subscription active. Once the subscription expires, the domain may no longer be able to access the website.',
  'connect_existing_domain': 'Connect Existing Domain',
  'if_you_have_existing_domain': 'If you already have a domain, you can connect it here',
  'connect_domain': 'Connect Domain',
  'loading': 'Loading...',
  'no_more': 'No more',
  
  // Domain Status - Verified
  'connected': 'Connected',
  'disconnect': 'Disconnect',
  
  // Domain Status - Invalid/Expired
  'invalid': 'Invalid',
  'expired': 'Expired',
  'reconnect': 'Reconnect',
  'reconfigure': 'Reconfigure',
  
  // Domain Status - Pending Verification
  'pending_verification': 'Pending Verification',
  'please_complete_configuration': 'Please complete the configuration. Time remaining:',
  'time_remaining': 'Time remaining: {time}',
  'check_again': 'Check Again',
  'use_a_record': 'Use A Record',
  'use_cname_record': 'Use CNAME',
  'record_type': 'Record Type',
  'record_name': 'Record Name',
  'value': 'Value',
  'empty_or_at': 'Empty or',
  'no_corresponding_records': 'No corresponding records of this type',
  'configuration': 'Configuration',
  'unknown': 'Unknown',
  
  // DNS Configuration Instructions
  'how_to_configure': 'How to Configure',
  'use_a_record_to_point': 'Use "{name}" to point your domain to the following IP address: {ip_address}',
  'use_cname_to_apply_to_root_domain': 'Use "{name}" to apply the CNAME to your root domain',
  'dns_propagation_notice': 'Note: After adding DNS records, changes may take some time to fully propagate across the internet.',
  
  // Connect Domain Dialog
  'connect_domain_dialog_title': 'Connect Domain ',
  'external_domain': 'External Domain',
  'if_you_have_domain_from_other_platform': 'If you already have a domain from another platform, you can connect it here.',
  'please_enter_domain': 'Please enter domain',
  'bind_both_domain_and_www': 'Set up both {domain} and www.{domain}',
  'recommended': 'Recommended',
  'cancel': 'Cancel',
  'confirm_connect': 'Confirm Connect',
  
  // Domain Conflict Dialog
  'domain_bind_notice': 'Domain Binding Notice',
  'following_domains_used_by_your_other_projects': 'The following domains are used by your other projects:',
  'you_can_rebind_to_current_project': 'You can rebind them to the current project',
  'rebind_now': 'Rebind Now',
  'following_domains_bound_by_other_users': 'The following domains are bound by other users and cannot be operated:',
  'already_occupied': 'Already Occupied',
  'close': 'Close',
  
  // Message Notifications
  'copied_to_clipboard': 'Copied to clipboard',
  'website_published_successfully': 'Website published successfully',
  'unpublished': 'Unpublished',
  'network_or_server_error': 'Network or server error, binding failed',
  'reconnect_request_failed': 'Reconnect request failed',
  'bind_success': 'Binding successful',
  'domain_already_bound_by_other_user': 'Domain {domain} has been bound by another user',
  'partial_bind_success': 'Partial binding successful: {domains}',
  'bind_failed': 'Binding failed',
  'rebind_success': 'Domain {domain} rebound successfully',
  'rebind_request_error': 'Rebind request error',
  'disconnected': 'Disconnected {domain}',
  'disconnect_failed': 'Disconnect failed',
  'dns_verification_passed': 'Domain {domain} DNS verification passed',
  'dns_verification_failed': 'DNS verification failed, please check your configuration',
  'check_dns_failed': 'Check DNS failed',
  'invalid_domain_format': 'Please enter a valid domain format',
  
  // WebPreviewPanel new keys
  'settings': 'Settings',
  'public_url': 'Public URL',
  'link_not_generated': 'Link not generated',
  'add_custom_domain': 'Custom Domain',
  'unknown_version': 'Unknown Version',
  'version_prefix': 'V{version}'
}
